import useTranslation from 'next-translate/useTranslation';
import type { ContestSettings } from '@betterpool/api-types/contests-service';
import { ContestSegmentType, SlateLabelEnum } from '@betterpool/api-types/contests-service';

import { Match } from '~/domains/common/components/Match/Match';
import { Text } from '~/domains/design-system/Text';

import { SectionNote } from '../components';

type PrizesSegmentsHeaderProps = {
  segments?: ContestSettings['segments'];
  slateLabel?: SlateLabelEnum;
};

function PrizesSegmentsHeader({
  slateLabel = SlateLabelEnum.SLATE,
  segments,
}: PrizesSegmentsHeaderProps) {
  const { t } = useTranslation('contest');

  return (
    <SectionNote mb={4}>
      <Text variant="subhead-small">
        <Match value={segments?.segmentType}>
          <Match.On value={[ContestSegmentType.MULTI_SLATE]}>
            {t('detail.prizes.segmentedPayouts.title')}
          </Match.On>
          <Match.On value={[ContestSegmentType.SINGLE_SLATE]}>
            {t('detail.prizes.slatePayouts.title', { slateLabel: slateLabel?.toLowerCase() })}
          </Match.On>
        </Match>
      </Text>
    </SectionNote>
  );
}

export default PrizesSegmentsHeader;
